import InputV2 from "@appComponents/InputV2";
import { Input, Modal, notification } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { use2FAFieldLogic } from "../../hooks/use2FAFieldLogic";
import { useAccountPageContext } from "../../AcountPage.context";
import { Button } from "../Button";
import ProfileService from "@services/Profile.service";
import { TAccountData, TValidation } from "../../IAccountPage";
import { DESKTOP_WIDTH } from "@bundles/consts";

type CloseAccountModalProps = {
  open?: boolean;
  onClose?: () => void;
};

export const CloseAccountModal = ({
  open,
  onClose,
}: CloseAccountModalProps) => {
  const [password, setPassword] = useState("");

  const { is2FAEnabled } = useAccountPageContext();

  const isMobile = useMediaQuery({ maxWidth: DESKTOP_WIDTH });

  const {
    inputRefs: twoFAInputRefs,
    pin: twoFAPin,
    handleChange: twoFAHandleChange,
    handleKeyDown: twoFAHandleKeyDown,
    handleClearPin: twoFAHandleClearPin,
    handlePaste: twoFAHandlePaste,
  } = use2FAFieldLogic();

  const isButtonDisabled = useMemo(() => {
    if (!password) {
      return true;
    }

    if (is2FAEnabled && twoFAPin.join("").length < 6) {
      return true;
    }

    return false;
  }, [password, is2FAEnabled, twoFAPin]);

  const handleSend = () => {
    const data = {
      old_password: password,
    } as TValidation;

    if (is2FAEnabled) {
      data.otp_code = twoFAPin.join("");
    }

    ProfileService.closeAccount({
      data,
    } as unknown as TAccountData)
      .then(() => {
        window.location.href = "/users/sign_out";
      })
      .catch(() => {
        notification.error({ message: "Something went wrong" });
      });
  };

  useEffect(() => {
    setPassword("");
    twoFAHandleClearPin();
  }, [open]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={isMobile ? "100%" : "70%"}
      className="tailwind-2fa-modal tailwind"
    >
      <div className="p-6">
        <h2 className="text-xl font-semibold mb-8">Close account</h2>

        <InputV2
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          label="Password"
          placeholder="Type here"
          shouldShowIconBeVisible={open}
        />

        {is2FAEnabled && (
          <div className="flex flex-col gap-2 mt-8">
            <div className="text-[16px] font-semibold">
              Enter valid 2FA token
            </div>
            <div className="flex gap-2">
              {twoFAPin.map((digit, index) => (
                <Input
                  key={index}
                  ref={(el) => (twoFAInputRefs.current[index] = el)}
                  value={digit}
                  maxLength={1}
                  onChange={(e) => twoFAHandleChange(index, e.target.value)}
                  onKeyDown={(e) => twoFAHandleKeyDown(index, e)}
                  onPaste={twoFAHandlePaste}
                  className="text-center text-lg font-semibold border border-grey-lighter tailwind-2fa-input"
                />
              ))}
            </div>
          </div>
        )}

        <div className="flex justify-center">
          <Button
            disabled={isButtonDisabled}
            style={{
              backgroundColor: !isButtonDisabled ? "#E02020" : "",
            }}
            className="mt-8 text-white"
            onClick={handleSend}
          >
            Close my Bnk To The Future account
          </Button>
        </div>
      </div>
    </Modal>
  );
};
